module.exports = __webpack_public_path__ + "img/logo.69136b4c.svg";